module.exports = __webpack_public_path__ + "img/ezgif.com-crop.4dd7de18.gif";